var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64",
    id: "near",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 20,
    fill: "#F3B844"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.3851 22.5173L33.9723 29.0663C33.6671 29.5123 34.2539 30.0522 34.6764 29.6766L39.0189 25.8974C39.1364 25.8035 39.3006 25.8739 39.3006 26.0383V37.8453C39.3006 38.0096 39.0894 38.0801 38.9955 37.9626L25.8505 22.2356C25.428 21.7192 24.8176 21.4375 24.1369 21.4375H23.6675C22.4469 21.4375 21.4375 22.4469 21.4375 23.6909V40.31C21.4375 41.554 22.4469 42.5634 23.6909 42.5634C24.4656 42.5634 25.1932 42.1644 25.6157 41.4837L30.0287 34.9346C30.3339 34.4887 29.747 33.9487 29.3245 34.3243L24.982 38.0801C24.8646 38.1739 24.7003 38.1035 24.7003 37.9392V26.1556C24.7003 25.9913 24.9115 25.9209 25.0054 26.0383L38.1504 41.7653C38.573 42.2817 39.2067 42.5634 39.864 42.5634H40.3335C41.5776 42.5634 42.5869 41.554 42.5869 40.31V23.6909C42.5634 22.4469 41.554 21.4375 40.31 21.4375C39.5353 21.4375 38.8077 21.8365 38.3851 22.5173V22.5173Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNear);
export default __webpack_public_path__ + "static/media/near.fd5d72ffef1bd49d728a4122cef66466.svg";
export { ForwardRef as ReactComponent };